import React from 'react';
import './NotFound.css';
import carImage from '../../assets/images/car.png'; 
import planeImage from '../../assets/images/plane.png'; 
import { useTranslation } from "../../contexts/TranslationContext";

const NotFound = ({ errorCode = "404", errorMessage, description}) => {
  const { t } = useTranslation();
  const message = errorMessage || t("NotFound");
  const desc = description || t("NotFoundMessageDescription");

  return (
    <div className="notfound-container">
    <div className="notfound-left">
      <div className="error-block">
        <img src={planeImage} alt="Plane" className="plane-image" />
        <h1>
          {
            errorCode && (
              <span className="error-code">{errorCode}</span>
            )
          }
          
          <span className="nofound-error-message" style={{ marginLeft: `${errorCode ? "10px" : "0px"}`}}>{message}</span>
        </h1>
      </div>
      <p className="not-found-description">{desc}</p>
      <div className="actions">
        <a href="/" className="link">{t("BackToHome")}</a>
        <a href="/contact" className="link">{t("ContactUs")}</a>
      </div>
    </div>
    <div className="notfound-right">
      <img src={carImage} alt="404 Illustration" className="car-image" />
    </div>
  </div>
  )
}

export default NotFound